import { render, staticRenderFns } from "./ResumenCardComponent.vue?vue&type=template&id=be6e0b58"
import script from "./ResumenCardComponent.vue?vue&type=script&lang=js"
export * from "./ResumenCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports